module.exports = __webpack_public_path__ + "37638d1acbb604b5bd878b746c438201.png";